import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { COLORS } from '../../styles/colors';
import AlertMessage from '../AlertMessage';
import { connect } from 'react-redux';
import withAuth from '../../hocs/withAuth';
import { sendInvitations } from '../../store/actions/auth';
import { checkValidEmail } from '../../helpers';
import { showAlert } from '../../store/actions/alert';
import { AlertJsMessage } from './../../helpers.js';
import { STRIPE_USER } from './../../constants';

/**
 * Partners
 */
export class Partners extends Component {
	// eslint-disable-line react/prefer-stateless-function

	componentDidMount() {}
	constructor(props) {
		super(props);
		this.state = {
			emailInput: '',
			showSentMessage: false,
		};
	}

	validateEmails(emails) {
		if (emails) {
			const emailArr = emails.split(',');
			const errorMail = emailArr.filter(email => !checkValidEmail(email));
			if (errorMail.length > 0) {
				AlertJsMessage(`The following emails are invalid. Please resolve before continuing.
        Note that spaces and line breaks are not allowed in email list. [${errorMail.toString()}]`);
				return false;
			}
		}
		return true;
	}

	copyToClipboard = url => {
		window.navigator.clipboard
			.writeText(url)
			.then(() => this.props.showAlert('Link copied to clipboard.'));
	};

	submitForm() {
		let emails = this.state.emailInput;
		if (!emails) {
			AlertJsMessage('No clients were selected.');
			return;
		} else if (!this.validateEmails(emails)) {
			return;
		} else {
			emails = emails.split(',');
			this.props
				.sendInvitations(emails)
				.then(data => {
					this.setState({
						emailInput: '',
					});
				})
				.catch(err => {
					AlertJsMessage(err.message);
				});
		}
	}

	/**
	 * @description redirectToPaymentGateWay method to redirect the payment gateway
	 */
	redirectToPaymentGateWay = () => {
		const redirectUrl = `${process.env.REACT_APP_URL}/successConnection?next=share`;
		const clientId = process.env.REACT_APP_STRIPE_CLIENT_ID;
		const pathArr = [
			process.env.REACT_APP_STRIPE_AUTH_URL,
			`redirect_uri=${redirectUrl}`,
			`client_id=${clientId}`,
		];
		window.location.href = `${pathArr.join('&')}&${STRIPE_USER}`;
	};

	render() {
		const { user } = this.props;
		let shareUrl;
		const { type } = user;
		if (type && type.includes('trainer')) {
			shareUrl = process.env.REACT_APP_URL + '/follow/' + user.referenceCode;
		}
		if (type && (type.includes('brand') || type.includes('corporate'))) {
			shareUrl = process.env.REACT_APP_URL + '/brand/' + user.referenceCode;
		}
		return (
			<div>
				<h1>Share</h1>
				<hr />
				{user && (user.stripeAccountId || !type.includes('trainer')) ? (
					<Fragment>
						Share your Fitbanx link with your audence and make more money!
						<div>
							<a
								ref={link => (this.shareLink = link)}
								style={{
									border: '1px solid ' + COLORS.grey,
									padding: 9,
									borderRadius: 5,
									position: 'relative',
									top: 1,
									marginRight: 5,
								}}
								href={shareUrl}
							>
								{shareUrl}
							</a>
							<Button
								onClick={() => this.copyToClipboard(shareUrl)}
								style={{ backgroundColor: COLORS.orange }}
								variant="contained"
								color="secondary"
							>
								Copy Link
							</Button>

							<div>
								Copy and paste your link on Facebook, Twitter, Instagram, and
								LinkedIn. You can also text this link to anyone you can imagine!
							</div>
						</div>
						{type && type.includes('trainer') && (
							<div>
								<h1>Send invitations by email</h1>
								<div
									style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
									}}
								>
									<div style={{ width: '50%' }}>
										<TextField
											rows={1}
											label="Emails"
											value={this.state.emailInput}
											onChange={e =>
												this.setState({ emailInput: e.target.value })
											}
											margin="dense"
											variant="outlined"
											placeholder="jon@doe.com,jane@doe.com"
											helperText="Enter email addresses separated by commas"
										/>
										{this.state.showSentMessage && (
											<AlertMessage
												subject="Invite Sent!"
												body=""
												icon={['far', 'check-square']}
											/>
										)}
									</div>
									<div style={{ marginLeft: 5 }}>
										<Button
											onClick={() => this.submitForm()}
											style={{ backgroundColor: COLORS.orange }}
											variant="contained"
											color="secondary"
										>
											Send Invites
										</Button>
									</div>
								</div>
							</div>
						)}
					</Fragment>
				) : (
					<Fragment>
						Before you can share your referral link with the world, we need to
						be able to pay you. Please connect with Stripe so we can pay you for
						our awesome workout creativity.
						<br />
						<br />
						<br />
						<div>
							<span id="cwppButton">
								<a
									class="stripe-connect"
									onClick={this.redirectToPaymentGateWay}
								>
									<span>Connect with Stripe</span>
								</a>
							</span>
						</div>
					</Fragment>
				)}
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	let {
		currentUser: { user },
	} = state;
	return {
		user: user,
	};
}
const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		sendInvitations: emails => {
			return dispatch(sendInvitations(emails));
		},
		showAlert: msg => dispatch(showAlert(msg)),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(withAuth(Partners));



// WEBPACK FOOTER //
// ./src/components/assignments/Partners.js